export enum ActionTypeEnum {
  create = "create",
  update = "update",
  delete = "delete",
  export = "export",
  mainErrorManagement = "main-error-management",
  modalErrorManagement = "modal-error-management"
}
